module.exports = __webpack_public_path__ + "img/HQ-ENC-V1-T.98f24eb6.jpg";